module.exports = __webpack_public_path__ + "img/116.ef03340d.jpg";